const developmentConfig = {
  env: 'development',
  apiUrl: 'http://localhost',
  sentryDsn: null,
  clarityProjectId: '',
  userbackToken: null,
};

const stagingConfig = {
  env: 'staging',
  // staging API URL
  apiUrl: 'https://idp-api-staging.livingplans.africa',
  sentryDsn: null,
  clarityProjectId: 'vione82bi8',
  userbackToken: 'A-tbC3sQeQrDN2kDzuKr8IqmpzB',
};

const productionConfig = {
  env: 'production',
  // production API URL
  apiUrl: 'https://idp-api.livingplans.africa',
  sentryDsn: 'https://bb4fdf69c7b5ca1f33c1e10adac8052b@o4509261195968512.ingest.de.sentry.io/4510901516632144',
  clarityProjectId: 'viao9ifgo7',
  userbackToken: 'A-tbC3sQeQrDN2kDzuKr8IqmpzB',
};

let config;
// This check is crucial to prevent errors during SSG build where `window` is not available.
if (typeof window !== 'undefined') {
  const hostname = window.location.hostname;
  // production webapp URL
  if (hostname === 'idp.livingplans.africa') {
    config = productionConfig;
  // staging webapp URL
  } else if (hostname === 'idp-staging.livingplans.africa') {
    config = stagingConfig;
  } else if (hostname === 'localhost') {
    // Dev user's browser runs on the host machine — localhost resolves to the host, where the API container's port 80 is exposed.
    config = developmentConfig;
  } else if (hostname === 'webapp') {
    // Puppeteer runs inside Docker, where localhost would resolve to its own container (nothing listening).
    // Docker's internal DNS lets containers reach each other by service name instead.
    config = { ...developmentConfig, apiUrl: 'http://nginx' };
  } else {
    config = stagingConfig;
  }
} else {
  config = stagingConfig;
}

export default config;
